export const redirect = (path: string) => {
    document.location = path;
};

export const scrollIntoView = (element: HTMLElement) => {
    // HTMLElement.scrollIntoView is undefined in 'node' environment (Eg. when running unit tests)
    if (!element || typeof element.scrollIntoView !== 'function') {
        return;
    }

    element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
    });
};

export const getFocusedElement = (): HTMLElement | null => {
    if (typeof document === 'undefined') {
        return null;
    }

    return document.activeElement as HTMLElement | null;
};
